import React, { ReactElement } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { colorsPalette } from '../../../styles/colors-palette';
const { Text: AntText } = Typography;

type TextType = 'secondary';
type TextSize = 'small' | 'middle' | 'large';

interface TextProps {
  children?: React.ReactNode;
  ellipsis?: boolean;
  bold?: boolean;
  color?: Color;
  underline?: boolean;
  type?: TextType;
  size?: TextSize;
  className?: string;
  tooltip?: string;
  whiteSpace?: React.CSSProperties['whiteSpace'];
}

function Text({
  children,
  type,
  size,
  bold,
  underline,
  ellipsis,
  className,
  tooltip,
  color,
  whiteSpace,
}: TextProps): ReactElement {
  return (
    <Styled
      title={tooltip}
      className={className}
      type={type}
      ellipsis={ellipsis}
      size={size}
      strong={bold}
      color={color}
      underline={underline}
      whiteSpace={whiteSpace}
    >
      {children}
    </Styled>
  );
}

const Styled = styled(AntText)<TextProps>`
  font-size: ${props => {
    switch (props.size) {
      case 'small':
        return '12px';
      case 'middle':
        return '14px';
      case 'large':
        return '16px';
      default:
        return '14px';
    }
  }};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  &.ant-typography.ant-typography-secondary {
    color: ${colorsPalette.gray200};
  }
  &.ant-typography {
    white-space: ${props => (props.ellipsis ? '' : 'pre-line')};
    color: ${props => props.color};
    white-space: ${props => props.whiteSpace};
  }
`;

export default Text;
